import React from "react";
import { Reveal } from "@/components/site/Reveal";

export const PageIntro = ({ eyebrow, title, description }) => (
  <section className="hero-gradient border-b" style={{ borderColor: "var(--card-border)" }}>
    <div className="container-inst pt-16 pb-14 lg:pt-24 lg:pb-20">
      <Reveal>
        {eyebrow && <p className="motif-caps">{eyebrow}</p>}
        <h1 className="mt-5 max-w-[24ch] text-[30px] leading-[1.18] sm:text-[38px] lg:text-[44px]" style={{ color: "var(--text)", fontWeight: 500, letterSpacing: "0.2px" }}>
          {title}
        </h1>
        <div className="bronze-rule mt-6" />
        {description && <p className="mt-7 max-w-[70ch] text-[16px] leading-[1.8]" style={{ color: "var(--muted)" }}>{description}</p>}
      </Reveal>
    </div>
  </section>
);

export const Prose = ({ blocks }) => (
  <div className="space-y-12">
    {blocks.map((b, i) => (
      <Reveal key={b.h} delay={i * 0.03}>
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-[240px_1fr] lg:gap-10">
          <h2 className="text-[19px]" style={{ color: "var(--text)", fontWeight: 500, letterSpacing: "0.3px" }}>{b.h}</h2>
          <div className="max-w-[70ch] space-y-4">
            {b.p.map((para, j) => (
              <p key={j} className="text-[15px] leading-[1.8] md:text-base" style={{ color: "var(--muted)" }}>{para}</p>
            ))}
          </div>
        </div>
      </Reveal>
    ))}
  </div>
);
